import { render, staticRenderFns } from "./users-list.scene.vue?vue&type=template&id=630c54d4"
import script from "./users-list.scene.ts?vue&type=script&lang=ts&external"
export * from "./users-list.scene.ts?vue&type=script&lang=ts&external"
import style0 from "./users-list.scene.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports